import { CustomerSchema } from "@redotech/redo-customer-common/customer";
import * as z from "zod";

/**
 * Resolves a customer from any combination of identifiers (Shopify customer id,
 * phone number, email), in that priority order. Returns null when none match.
 * Unlike `getCustomerByEmail`, this tolerates a missing/empty email so callers
 * with a return's full customer summary (which often has no email but does have
 * a phone or Shopify id) can still resolve the customer.
 */
export const getCustomerByIdentifiers = {
  name: "getCustomerByIdentifiers" as const,
  input: z.object({
    email: z.string().optional(),
    phoneNumber: z.string().optional(),
    shopifyCustomerId: z.string().optional(),
  }),
  output: CustomerSchema.nullable(),
};
